import { useTranslation } from "react-i18next";
import dayjs from "dayjs";
import "dayjs/locale/ko";
import "dayjs/locale/ja";
import "dayjs/locale/zh-cn";
import "dayjs/locale/zh-tw";
import customParseFormat from "dayjs/plugin/customParseFormat";
import localizedFormat from "dayjs/plugin/localizedFormat";

dayjs.extend(customParseFormat);
dayjs.extend(localizedFormat);

// 다국어별 로케일 매핑
const localeMap: { [key: string]: string } = {
  ko: "ko",
  en: "en",
  ja: "ja",
  "zh-CN": "zh-cn",
  "zh-TW": "zh-tw",
};

// 채널 리스트 시간 포맷 함수
export const formatChannelListTime = (timestamp: number, locale: string = "ko"): string => {
  const dayjsLocale = localeMap[locale] || "en";
  dayjs.locale(dayjsLocale);
  
  const messageTime = dayjs(timestamp);
  const now = dayjs();
  const today = now.startOf("day");
  const yesterday = today.subtract(1, "day");
  
  // 오늘인 경우
  if (messageTime.isAfter(today)) {
    if (locale === "ko") {
      // 한국어: 오전/오후 표시
      const hour = messageTime.hour();
      const minute = messageTime.format("mm");
      const period = hour < 12 ? "오전" : "오후";
      const displayHour = hour === 0 ? 12 : hour > 12 ? hour - 12 : hour;
      return `${period} ${displayHour}:${minute}`;
    } else if (locale === "ja") {
      // 일본어: 午前/午後
      const hour = messageTime.hour();
      const minute = messageTime.format("mm");
      const period = hour < 12 ? "午前" : "午後";
      const displayHour = hour === 0 ? 12 : hour > 12 ? hour - 12 : hour;
      return `${period} ${displayHour}:${minute}`;
    } else if (locale === "zh-CN" || locale === "zh-TW") {
      // 중국어: 上午/下午
      const hour = messageTime.hour();
      const minute = messageTime.format("mm");
      const period = hour < 12 ? "上午" : "下午";
      const displayHour = hour === 0 ? 12 : hour > 12 ? hour - 12 : hour;
      return `${period} ${displayHour}:${minute}`;
    } else {
      // 영어 및 기타
      return messageTime.format("h:mm A");
    }
  }
  
  // 어제인 경우
  if (messageTime.isAfter(yesterday) && messageTime.isBefore(today)) {
    if (locale === "ko") {
      return "어제";
    } else if (locale === "ja") {
      return "昨日";
    } else if (locale === "zh-CN" || locale === "zh-TW") {
      return "昨天";
    } else {
      return "Yesterday";
    }
  }
  
  // 그 외의 경우
  return messageTime.format("YYYY-MM-DD");
};

// React 컴포넌트에서 사용할 수 있는 Hook
export const useChannelListTimeFormatter = () => {
  const { i18n } = useTranslation();
  
  return (timestamp: number) => {
    return formatChannelListTime(timestamp, i18n.language);
  };
};